import script from "./LayoutDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./LayoutDashboard.vue?vue&type=style&index=0&id=3231396f&lang=css"

const __exports__ = script;

export default __exports__